module.exports = "/images/sub-warning.png?5eac7b2cde14abb867f7f35a0c9f6f87";